const UNITS = ["B", "KB", "MB", "GB"] as const;

/** Compact human-readable file size for upload lists. */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1,
  );
  const value = bytes / 1024 ** exponent;
  const formatted =
    exponent === 0 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, "");

  return `${formatted} ${UNITS[exponent]}`;
}
